import React, { useContext, useState } from 'react';
import { ForgotPasswordV } from 'react-forgot-password';
import { ThemeContext } from '../../../providers/theme';
import { EventBus } from 'event-bus-vfs';
import { FORM_VALUES, defaultValuesDS } from 'react-form-rs';
import { useHistory, useLocation, Prompt } from 'react-router-dom';
import blueprint from '../config/default-bluprint.json';
import Alert from 'rsuite/lib/Alert';
import { IProps } from './index'
const BP = blueprint;
let formContext = {};

export const ForgotPasswordLG = (props: IProps) => {
    const [validateForm, setValidateForm] = React.useState<any>(null);
    const theme = useContext(ThemeContext);
    const [date, setDate] = React.useState<Date>(new Date());
    const history = useHistory();
    React.useEffect(() => {
        const app = EventBus.on(FORM_VALUES, value => {
            formContext = { ...value };
        });
        return function () {
            app.off();
        };
    }, []);

    const handleValidateResult = (
        formContext: any,
        status: 'success' | 'error',
        validateResult: any,
    ) => {
        if (status === 'success') {
            //console.log('forgotPassword data collected successful', defaultValuesDS.get('emailAddress')?.defaultValue,);
            props.onForgotPassword &&
                props.onForgotPassword(
                    defaultValuesDS.get('emailAddress')?.defaultValue,
                );
            defaultValuesDS.clear();
        }
        if (status === 'error') {
            BP.forgotPassordErr && Alert.error(BP.forgotPassordErr, 10000);
        }
        setDate(new Date());
        setValidateForm(false);
    };

    const onBackButtonPress = () => {
        history.push('/login')
    }
    return (
        <>
            <ForgotPasswordV
                width={'100%'}
                height={'100vh'}
                containerStyle={{ width: '100%', height: '100vh' }}
                title={BP?.title}
                leftAvatar={BP?.headerLogo}
                backButtonTitle={'Back'}
                backButtonColor={'black'}
                backButtonId={'backButton'}
                submitButtonTitle={'Submit'}
                submitButtonColor={theme?.palette?.secondary}
                submitButtonId={'submitButton'}
                bodyTitle={BP?.bodyTitle}
                formFields={BP?.formFields}
                formContext={formContext}
                validateForm={validateForm}
                defaultValues={defaultValuesDS.get()}
                onHeaderLogoPress={() => alert('handle navigation')}
                onValidateResult={handleValidateResult}
                onSubmitButtonPress={() => {
                    setValidateForm({
                        ...formContext,
                    });
                }}
                onBackButtonPress={onBackButtonPress}
                waveColor={theme?.palette?.secondary}
                loading={false}
            />
        </>
    )
}